import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class BaseService<T> {
    /**
     * Base URL for the API endpoint.
     * @protected
     */
    protected readonly URL: string = "<API_ENDPOINT>";

    /**
     * HttpClient instance for making HTTP requests.
     * @protected
     */
    protected _httpClient: HttpClient = inject(HttpClient);

    /**
     * BehaviorSubjects for the current item and list of items.
     * @protected
     */
    protected _item: BehaviorSubject<T | null> = new BehaviorSubject(null);
    protected _items: BehaviorSubject<T[]> = new BehaviorSubject([]);

    /**
     * Getter for items
     */
    get items$(): Observable<T[]> {
        return this._items.asObservable();
    }

    /**
     * Getter for item
     */
    get item$(): Observable<T> {
        return this._item.asObservable();
    }

    /**
     * Formatea los parámetros de entrada para una solicitud HTTP.
     * Si algún parámetro es un archivo, convierte los datos a FormData.
     *
     * @param data - Los datos a formatear.
     * @returns Un objeto con los parámetros formateados o un FormData si hay archivos.
     */
    protected _formatParams(data: any): { [key: string]: any } | FormData {
        // Verificar si algún parámetro es un archivo
        const hasFile: boolean = Object.values(data).some((value): boolean => value instanceof File);

        if (hasFile) {
            let formData: FormData = new FormData();

            // Iterar sobre cada clave en el objeto de datos
            Object.keys(data).forEach((key: string): void => {
                const value: any = data[key];

                // Si el valor es un archivo, añadirlo a FormData
                if (value instanceof File) {
                    formData.append(key, value, value.name);
                }
                // Si el valor es un array, iterar sobre cada elemento
                else if (Array.isArray(value)) {
                    value.forEach((item: any, index: number): void => {
                        if (item instanceof File) {
                            formData.append(`${key}[${index}]`, item, item.name);
                        } else {
                            formData.append(`${key}[${index}]`, item);
                        }
                    });
                }
                // Si el valor es un objeto, convertirlo a JSON y añadirlo a FormData
                else if (typeof value === "object" && value !== null) {
                    formData.append(key, JSON.stringify(value));
                }
                // Si el valor es un tipo primitivo, añadirlo directamente a FormData
                else {
                    formData.append(key, value);
                }
            });

            // Verificar el contenido de FormData
            formData.forEach((value, key) => {
                console.log(`FormData - key: ${key}, value: ${value}`);
            });

            return formData; // Asegúrate de retornar el formData
        }

        return data; // Retornar el objeto original si no hay archivos
    }
}
